import Ajax from 'core/Ajax';
import Facade from 'core/Facade';

class HttpService {

    /**
     *
     * Perform an HTTP call
     *
     */
    request(options) {
        const apiRoot = Facade.getApiRoot();

        // Handle authentication
        if (options.url.indexOf(apiRoot) === 0) {
            let userToken = null;
            // user authentication
            userToken = localStorage.getItem('pricecomparator_token');
            if (userToken) {
                if (!options.headers) {
                    options.headers = {};
                }
                options.headers.Authorization = 'bearer ' + userToken;
            }
        }

        return Ajax.call(options);
    }
}

export default new HttpService();
